export const APP_TYPES = [
  {
    id: 'admin',
    label: 'Admin',
    description: `Admin apps enhance your store's backend`,
  },
  {
    id: 'storefront',
    label: 'Storefront',
    description: `Storefront apps provide customer-facing features`,
  },
  {
    id: 'channel',
    label: 'Sales channel',
    description: `Sales channels enable you to sell on other platforms`,
  },
  {
    id: 'integration',
    label: 'Integration',
    description: `Integrations provide a connection between your store and another platform`,
  },
  {
    id: 'theme',
    label: 'Theme',
    description: `Themes provide a customizable look-and-feel for Storefront apps`,
  },
];

export const APP_CATEGORIES = [
  {
    id: 'sales_channels',
    label: 'Sales channels',
    description: `Sales channels enable you to sell on other platforms.`,
    categories: [
      {
        id: 'selling_in_person',
        label: 'Selling in person',
        categories: [
          {
            id: 'retail',
            label: 'Retail',
          },
          {
            id: 'sku_and_barcodes',
            label: 'SKU and barcodes',
          },
          {
            id: 'store_locator',
            label: 'Store locator',
          },
        ],
      },
      {
        id: 'selling_online',
        label: 'Selling online',
        categories: [
          {
            id: 'marketplaces',
            label: 'Marketplaces',
          },
          {
            id: 'product_feeds',
            label: 'Product feeds',
          },
          {
            id: 'store_data_importer',
            label: 'Store data importer',
          },
        ],
      },
    ],
  },
  {
    id: 'finding_products',
    label: 'Finding products',
    description: `Sales channels enable you to sell on other platforms`,
    categories: [
      {
        id: 'dropshipping',
        label: 'Dropshipping',
      },
      {
        id: 'print_on_demand',
        label: 'Print on demand',
      },
      {
        id: 'wholesale',
        label: 'Wholesale',
      },
    ],
  },
  {
    id: 'selling_products',
    label: 'Selling products',
    description: `More kinds of products, more ways to pay.`,
    categories: [
      {
        id: 'custom_products',
        label: 'Custom products',
        categories: [
          {
            id: 'custom_file_upload',
            label: 'Custom file upload',
          },
          {
            id: 'product_variants',
            label: 'Product variants',
          },
        ],
      },
      {
        id: 'digital_goods_and_services',
        label: 'Digital goods and services',
        categories: [
          {
            id: 'digital_products',
            label: 'Digital products',
          },
          {
            id: 'event_booking',
            label: 'Event booking',
          },
          {
            id: 'nfts_and_tokengating',
            label: 'NFTs and tokengating',
          },
        ],
      },
      {
        id: 'payment_options',
        label: 'Payment options',
        categories: [
          {
            id: 'cash_on_delivery',
            label: 'Cash on delivery (COD)',
          },
          {
            id: 'payments',
            label: 'Payments',
          },
          {
            id: 'subscriptions',
            label: 'Subscriptions',
          },
        ],
      },
      {
        id: 'pricing',
        label: 'Pricing',
        categories: [
          {
            id: 'pricing_optimization',
            label: 'Pricing optimization',
          },
          {
            id: 'pricing_quotes',
            label: 'Pricing quotes',
          },
        ],
      },
    ],
  },
  {
    id: 'orders_and_shipping',
    label: 'Orders and shipping',
    description: `Get orders out the door.`,
    categories: [
      {
        id: 'inventory',
        label: 'Inventory',
        categories: [
          {
            id: 'erp',
            label: 'ERP',
          },
          {
            id: 'inventory_optimization',
            label: 'Inventory optimization',
          },
          {
            id: 'inventory_sync',
            label: 'Inventory sync',
          },
        ],
      },
      {
        id: 'orders',
        label: 'Orders',
        categories: [
          {
            id: 'invoices_and_receipts',
            label: 'Invoices and receipts',
          },
          {
            id: 'order_editing',
            label: 'Order editing',
          },
          {
            id: 'order_tracking',
            label: 'Order tracking',
          },
        ],
      },
      {
        id: 'returns_and_warranty',
        label: 'Returns and warranty',
        categories: [
          {
            id: 'returns_and_exchanges',
            label: 'Returns and exchanges',
          },
          {
            id: 'warranties_and_insurance',
            label: 'Warranties and insurance',
          },
        ],
      },
      {
        id: 'shipping_solutions',
        label: 'Shipping solutions',
        categories: [
          {
            id: 'delivery_and_pickup',
            label: 'Delivery and pickup',
          },
          {
            id: 'shipping',
            label: 'Shipping',
          },
          {
            id: 'shipping_rates',
            label: 'Shipping rates',
          },
          {
            id: 'third_party_logistics',
            label: 'Third-party logistics (3PL)',
          },
        ],
      },
    ],
  },
  {
    id: 'store_design',
    label: 'Store design',
    description: `Make your store look great.`,
    categories: [],
  },
  {
    id: 'marketing_and_conversion',
    label: 'Marketing and conversion',
    description: `Get more customers and make more sales.`,
    categories: [],
  },
  {
    id: 'store_management',
    label: 'Store management',
    description: `Manage your store.`,
    categories: [],
  },
];

export const APP_STOREFRONT_USE_CASES = [
  {
    id: 'direct_to_consumer',
    label: 'Direct to consumer',
    description: `Direct to consumer apps are designed for selling directly to consumers`,
  },
  {
    id: 'wholesale',
    label: 'Wholesale',
    description: `Wholesale apps are designed for selling to other businesses`,
  },
  {
    id: 'marketplace',
    label: 'Marketplace',
    description: `Marketplace apps are designed for selling products from multiple vendors`,
  },
  {
    id: 'digital_goods',
    label: 'Digital goods',
    description: `Digital goods apps are designed for selling digital products`,
  },
];

export const APP_STOREFRONT_PURCHASE_OPTIONS = [
  {
    id: 'standard',
    label: 'Standard',
    description: `Sell one-time purchases`,
  },
  {
    id: 'subscription',
    label: 'Subscription',
    description: `Sell recurring purchases on a schedule`,
  },
  {
    id: 'preorder',
    label: 'Preorder',
    description: `Sell products before they're available for delivery`,
  },
];

export const APP_STOREFRONT_FEATURES = [
  {
    id: 'multi_currency',
    label: 'Multi-currency',
    description: `Multi-currency apps support selling in multiple currencies`,
  },
  {
    id: 'multi_language',
    label: 'Multi-language',
    description: `Multi-language apps support selling in multiple languages`,
  },
  {
    id: 'bulk_pricing',
    label: 'Bulk pricing',
    description: `Bulk pricing apps support selling in bulk`,
  },
  {
    id: 'account_pricing',
    label: 'Account pricing',
    description: `Account pricing apps support selling to different customer groups`,
  },
];